import { Icon } from "../Icon";
import { forwardRef } from "react";
import { Box, BoxProps, IconButton } from "@mui/material";

/**
 * 사이드 패널 상단의 닫기 버튼 바 (40px 높이, 회색 배경, 우측 닫기 아이콘).
 */
export interface SideSpacerProps extends BoxProps {
  onClose: () => void;
}

export const SideSpacer = forwardRef<HTMLDivElement, SideSpacerProps>(
  ({ onClose, ...props }, ref) => {
    return (
      <Box ref={ref} sx={container} {...props}>
        <IconButton sx={button} onClick={onClose}>
          <Icon name="24/nav/basic/left-panel-close" size={24} />
        </IconButton>
      </Box>
    );
  }
);

SideSpacer.displayName = "SideSpacer";

const container = {
  width: "100%",
  maxWidth: 320,
  height: 40,
  padding: "2px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  backgroundColor: "rgba(0, 0, 0, 0.04)",
};

const button = {
  width: 30,
  height: 30,
  minWidth: "unset",
  padding: "0",
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
};
